export default __webpack_public_path__ + "static/media/smiley.653dad91.png";